angular.module('zc.users.pages')

.directive 'zcFooterLinks', ($stateParams, $rootScope, $translate, Project, Environment) ->
  restrict: 'E'
  templateUrl: '/templates/users.pages/views/directives/footer_links.html'



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users.pages/directives/footer_links_directive.js.coffee